"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const graphql_tag_1 = __importDefault(require("graphql-tag"));
const fragments_1 = require("../fragments");
const BlogPostsByEcommQuery = (0, graphql_tag_1.default) `
  query blogPostByEcommCategory(
    $categoryId: String = ""
    $subCategoryId: String = ""
    $blogPostQuantity: Int = 3
  ) {
    blogPostsByEcomm(
      ecommCategory: $categoryId
      ecommSubcategory: $subCategoryId
      quantity: $blogPostQuantity
    ) {
      posts {
        ...posts
      }
    }
  }
  ${fragments_1.BlogPostFragment}
`;
exports.default = BlogPostsByEcommQuery;
